import {
	ColourOutline,
	FlexGap,
	FlexJustify,
	Pill,
	StackHorizontal,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import { FormatLocaleDate } from '@ukpostbox/helpers';
import React from 'react';
import { useNavigate } from 'react-router';
import { useMailbox } from '../../../Mailboxes/Providers/NewMailboxProvider';
import { useSite } from '../../../_Global/Providers/SiteInterfaceProvider';
import { useMailboxesStore } from '../../../Mailboxes/Providers/Stores/MailboxesStore';

function MailItemMetaPills() {
	const navigate = useNavigate();

	const { t } = useTranslation();
	const { currentLocale } = useSite();

	const { isTiny, isSmall, isMedium } = useLayout();
	const { mailItemData } = useMailbox();

	const mailItemOnHold = useMailboxesStore((state) => state.mailItemOnHold);
	const mailItemRequiresTopUp = useMailboxesStore((state) => state.mailItemRequiresTopUp);

	return (
		<>
			{mailItemOnHold && (
				<h6 className='m-0 text-white'>
					{t('mailItem.locked.title', { reason: mailItemData?.holdReason?.holdReasonDescription })}
				</h6>
			)}

			{mailItemRequiresTopUp && <h6 className='m-0 text-white'>{t('mailItem.messages.topUpRequired')}</h6>}

			{!mailItemOnHold && !mailItemRequiresTopUp && (
				<StackHorizontal
					gap={FlexGap.ExtraSmall}
					justify={isTiny || isSmall || isMedium ? FlexJustify.Center : FlexJustify.Start}
					wrap
				>
					{mailItemData?.willBeIncludedInNextAutomaticForward && (
						<Pill content={t('mailItem.labels.inAutoForwarding')} colour={ColourOutline.Secondary} />
					)}

					{mailItemData?.clientFolder && (
						<div
							role='button'
							tabIndex={0}
							onClick={() => navigate(`/mail/custom-folder/${mailItemData.clientFolder?.id}`)}
							onKeyDown={(e) =>
								e.key === 'Enter'
									? navigate(`/mail/custom-folder/${mailItemData.clientFolder?.id}`)
									: undefined
							}
						>
							<Pill
								content={`${t('labels.folder')}: ${mailItemData?.clientFolder?.description}`}
								colour={mailItemData?.clientFolder?.colour}
							/>
						</div>
					)}

					{mailItemData?.mailAction?.status === 'pending' && (
						<Pill
							content={t('status.dynamicType', {
								action: `${mailItemData?.mailAction.description} ${mailItemData?.mailAction.status}`,
							})}
							colour={ColourOutline.Warning}
						/>
					)}

					{mailItemData?.daysUntilNextStorageCharge !== null && (
						<Pill
							content={t('mailItem.labels.storageCharges', {
								number: mailItemData?.daysUntilNextStorageCharge,
							})}
							colour={
								mailItemData?.daysUntilNextStorageCharge &&
								mailItemData?.daysUntilNextStorageCharge <= 5
									? ColourOutline.Alert
									: ColourOutline.Secondary
							}
						/>
					)}

					{mailItemData?.mailLocationId !== undefined && (
						<Pill content={t('mailItem.labels.location', { location: mailItemData?.mailLocationId })} />
					)}

					<Pill
						content={
							mailItemData?.dateReceived
								? t('mailItem.labels.dateReceived', {
										date: FormatLocaleDate(mailItemData?.dateReceived, currentLocale),
									})
								: ''
						}
						colour={ColourOutline.Secondary}
					/>
				</StackHorizontal>
			)}
		</>
	);
}

export { MailItemMetaPills };
